import { request } from "@/api/common";
import apis from "@/common/config/host";
const DEEPLINK_OUT =
  apis.actApiDomain + "/act-api/Api/Activitypage/getUrlList";
  // http://sim335.rlab.sim.intra.xiaojukeji.com/act-api/Api/Activitypage/getUrlList

export const getDeeplink = function (params) {
  return request.get(DEEPLINK_OUT, params);
}
